import React from "react";

import Header from "./Header";
import Footer from "./Footer";
import './PrivacyPolicy.css';

import {
    BrowserRouter as Router,
    Link
} from "react-router-dom";

import img1_1 from '../img/LogoGuideline/1-1.webp';
import img1_2 from '../img/LogoGuideline/1-2.webp';
import img1_3 from '../img/LogoGuideline/1-3.webp';

import img2_1 from '../img/LogoGuideline/2-1.webp';
import img2_2 from '../img/LogoGuideline/2-2.webp';
import img2_3 from '../img/LogoGuideline/2-3.webp';
import img2_4 from '../img/LogoGuideline/2-4.webp';

import img3_1 from '../img/LogoGuideline/3-1.webp';
import img3_2 from '../img/LogoGuideline/3-2.webp';
import img3_3 from '../img/LogoGuideline/3-3.webp';
import img3_4 from '../img/LogoGuideline/3-4.webp';
import img3_5 from '../img/LogoGuideline/3-5.webp';

import img4_1 from '../img/LogoGuideline/4-1.webp';
import img4_2 from '../img/LogoGuideline/4-2.webp';

import img5_1 from '../img/LogoGuideline/5-1.webp';

import img6_1 from '../img/LogoGuideline/6-1.webp';
import img6_2 from '../img/LogoGuideline/6-2.webp';
import img6_3 from '../img/LogoGuideline/6-3.webp';
import img6_4 from '../img/LogoGuideline/6-4.webp';
import img6_5 from '../img/LogoGuideline/6-5.webp';
import img6_6 from '../img/LogoGuideline/6-6.webp';

import img7_1 from '../img/LogoGuideline/7-1.webp';
import img7_2 from '../img/LogoGuideline/7-2.webp';
import img7_3 from '../img/LogoGuideline/7-3.webp';
import img7_4 from '../img/LogoGuideline/7-4.webp';

const container1 = [
    {
        "item": {
            "images": [
                {
                    "title": "LOGO TYPE A",
                    "isOK": null,
                    "img": img1_1,
                },
                {
                    "title": "LOGO TYPE B",
                    "isOK": null,
                    "img": img1_2,
                },
                {
                    "title": "LOGO TYPE C",
                    "isOK": null,
                    "img": img1_3,
                },
            ],
        },
        "text": "",
    },
];

const container2 = [
    {
        "item": {
            "images": [
                {
                    "isOK": true,
                    "img": img2_1,
                }
            ],
        },
        "text": "There is no change applied to the NFT artwork. No problem at all.",
    },
    {
        "item": {
            "images": [
                {
                    "isOK": true,
                    "img": img2_2,
                },
                {
                    "isOK": false,
                    "img": img2_3,
                }
            ],
        },
        "text": "Changing the background is not a problem, but anything that infringes the copyrights, trademarks, portrait rights, or other rights of third parties, offends public order and morals, or deviates from the brand image of BŌSŌ TOKYO is prohibited.",
    },
    {
        "item": {
            "images": [
                {
                    "isOK": true,
                    "img": img2_4,
                }
            ],
        },
        "text": "As long as you are the owner of the artwork, you may have multiple pieces of artwork side by side.",
    },

];

const container3 = [
    {
        "item": {
            "images": [
                {
                    "isOK": false,
                    "img": img3_1,
                },
                {
                    "isOK": false,
                    "img": img3_2,
                },
                {
                    "isOK": false,
                    "img": img3_3,
                },
                {
                    "isOK": false,
                    "img": img3_4,
                },
            ],
        },
        "text": "Removing, adding, or altering the parts that make up the avatar, or altering the outline of the avatar is prohibited. This includes, for example, adding different parts, compositing, glitching, or otherwise manipulating the image, as in the example above.",
    },
    {
        "item": {
            "images": [
                {
                    "isOK": false,
                    "img": img3_5,
                },
            ],
        },
        "text": "Flipping the artwork is prohibited as well. (This is because it changes the meaning of the original artwork).",
    },
];

const container4 = [
    {
        "item": {
            "images": [
                {
                    "isOK": true,
                    "img": img4_1,
                },
                {
                    "isOK": true,
                    "img": img4_2,
                },
            ],
        },
        "text": "Owner may trim the artwork and logo to the extent necessary for the legitimate use of the artwork and logo. ",
    },
];

const container5 = [
    {
        "item": {
            "images": [
                {
                    "isOK": true,
                    "img": img5_1,
                },
            ],
        },
        "text": "Changing the color scheme of the avatar is not allowed, but making the entire avatar monotone or monochromatic is allowed.",
    },
];

const container6 = [
    {
        "item": {
            "images": [
                {
                    "isOK": false,
                    "img": img6_1,
                },
            ],
        },
        "text": "Please refrain from using or recombining elements of the logo in separate pieces.",
    },
    {
        "item": {
            "images": [
                {
                    "isOK": false,
                    "img": img6_2,
                },
                {
                    "isOK": true,
                    "img": img6_3,
                },
                {
                    "isOK": true,
                    "img": img6_4,
                },
            ],
        },
        "text": "",
    },
    {
        "item": {
            "images": [
                {
                    "isOK": null,
                    "title": "BŌSŌ RED",
                    "img": img6_5,
                },
                {
                    "isOK": null,
                    "title": "BŌSŌ BLACK",
                    "img": img6_6,
                },
            ],
        },
        "text": "Colors must be BOSO RED and BOSO BLACK. Changing the color of the logo is prohibited, however white is an exception.",
    },
];

const container7 = [
    {
        "item": {
            "images": [
                {
                    "isOK": false,
                    "img": img7_1,
                },
                {
                    "isOK": true,
                    "img": img7_2,
                },
            ],
        },
        "text": "The logo is intended as a supplement to the NFT artwork. Commercial usage of the logo alone is not permitted. Please be sure to use it with your NFT artwork.",
    },
    {
        "item": {
            "images": [
                {
                    "isOK": false,
                    "img": img7_3,
                },
                {
                    "isOK": true,
                    "img": img7_4,
                },
            ],
        },
        "text": "You may change the background image of the logo, but please do not deviate from the brand image of BŌSŌ TOKYO. Also, adjust the logo so that it is legible.",
    },
];

// block
const Block = (props) => {
    return (
        <>
            <div className="LogoGuidelineContainer__item">

                {/* title */}
                {props.item.title ? (
                    <h4 className="LogoGuidelineContainer__title">{props.item.title}</h4>
                ) : null}

                {/* OK or NG */}
                {props.item.isOK !== null && props.item.isOK ? (
                    <h4 className="LogoGuidelineContainer__title--OK">OK</h4>
                ) : null}
                {props.item.isOK !== null && props.item.isOK == false ? (
                    <h4 className="LogoGuidelineContainer__title--NG">NG</h4>
                ) : null}

                {/* image */}
                <img src={props.item.img} alt={props.item.img} />
            </div>
        </>
    )
}

// row container
const GuideRowContainer = (props) => {
    return (
        <div>
            <div className="LogoGuidelineContainer__itemContainer">
                {
                    props.container.item.images.map((item, index) => {
                        return (
                            <Block item={item} key={index} />
                        )
                    })
                }
            </div>
            <p className="LogoGuidelineContainer__text">{props.container.text}</p>
        </div>
    )
}

// column container
const GuideContainer = (props) => {
    return (
        <div className="LogoGuidelineContainer">
            {props.items.map((container, index) => {
                return (
                    <GuideRowContainer container={container} key={index} />
                )
            })
            }

        </div>
    )
}

export default function LogoGuideline() {
    return (
        <div>
            <Header />
            <div className="PrivacyPolicy">
                <div className="PrivacyPolicy__h2--text">
                    BŌSŌ TOKYO NFTs / Logo Terms of Usage<br /> Regarding Commercial Usage
                </div>
                <p className="PrivacyPolicy__date">AUG 19th , 2022</p>

                <p>BŌSŌ TOKYO hereby establishes the following license conditions regarding the commercial usage<br /> of the BŌSŌ TOKYO NFTs (hereinafter referred to as "NFTs") and the logos below.</p>

                <h3>1. Subject of the License</h3>
                <p>Any person who legally owns the NFTs and agrees to the <Link to="/rule">Terms of Use</Link> (hereinafter referred to as "Owner") may use the artwork of the NFTs and the logos below for commercial purposes as long as they comply with these terms and conditions.</p>

                <h3>2. Licensed logos</h3>
                <p>The logos for which commercial use is authorized under these Terms and Conditions are the following.<br />
                    "BŌSŌ TOKYO CREW"</p>

                {/* 画像コンテナ */}
                <GuideContainer items={container1} />

                <h3>3. Prior Consent</h3>
                <p>Prior to its commercial usage, the Owner shall upload an image of how the NFT artwork or logo, will be modified or reproduced, to "#Commercial Licenses".<br />
                    Commercial use without this prior consent shall not be permitted in any case.<br />
                    The fact that BŌSŌ TOKYO does not comment on the upload does not imply permission.</p>

                <h3>4. Prohibition</h3>
                <p>The use of NFTs and logos in the following ways are prohibited.<br />
                    a. Infringes the copyright, trademark, portrait rights or other rights of BŌSŌ TOKYO or a third party.<br />
                    b. Affirms or encourages discrimination, violence, domination, insult or fraud.<br />
                    c. To make it look as if it were BŌSŌ TOKYO official products or collaboration, services.<br />
                    d. Using only the logo and not using the NFT artwork.<br />
                    e. In a manner that does not conform to BŌSŌ TOKYO's brand image.</p>

                <h3>5. Alteration, Reproduction and Placement</h3>
                <p>When modifying, reproducing or placing NFT artworks or logos for commercial use, the following conditions must be adhered to.</p>

                <hr />

                <p>See also the following guideline images</p>

                <p>a. 	Owner may choose not to use a background, change the color of the background, or change the background completely. However, it is essential that the background does not infringe on the rights of third parties, does not encourage discrimination, etc., and is consistent with the BŌSŌ TOKYO brand image.</p>

                {/* 画像コンテナ */}
                <GuideContainer items={container2} />

                <hr />

                <p>b. Owner may not exclude any parts of the avatar, change a given part of the avatar, nor alter the outline of the avatar. Reversing the character's orientation (flipping the image horizontally) is also not permitted.</p>
                {/* 画像コンテナ */}
                <GuideContainer items={container3} />

                <hr />

                <p>c. Owner may trim the artwork and logo to the extent necessary for the legitimate use of the artwork and logo. For example, if you aim to use your NFT artwork as a smartphone case, yo are permitted to crop the image so that it matches the shape of the smartphone case.</p>
                {/* 画像コンテナ */}
                <GuideContainer items={container4} />

                <hr />

                <p>d. Owner may not change the color scheme of the characters in the artwork. However, you may make the entire character monotone or monochromatic.</p>
                {/* 画像コンテナ */}
                <GuideContainer items={container5} />
                <hr />

                <p>e. Changing the color scheme of the logo is not permitted.</p>
                {/* 画像コンテナ */}
                <GuideContainer items={container6} />

                <hr />

                <p>f. Owner may not transform the logo in anyway. Transformations of the logo are permitted only for the above-mentioned cropping and enlargement or reduction of the logo, which may occur only with the aspect ratio maintained.</p>
                {/* 画像コンテナ */}
                <GuideContainer items={container7} />
            </div>
            <Footer />
        </div>
    );
}